const testValues = [
  22, 33, 44, 55, 66, 77, 88, 99,
  222, 333, 444, 555, 666, 777, 888, 999
]

const numberRedundancyCheck  = function (quantity) {
  return testValues.includes(quantity)
}

export default numberRedundancyCheck
